@let incidents = incidentStore.incidents;
@if (incidentStore.isLoading()) {
  <div class="pt-32">
    <aw-loading-animation></aw-loading-animation>
  </div>
}
@if (incidents() && !incidentStore.isLoading()) {
  <aw-section testIdAffix="allIncidents">
    <aw-section-header>
      <aw-section-headline>
        {{ cmsTextProvider.shared.incidentMonitor }}
      </aw-section-headline>
    </aw-section-header>
    <aw-incident-chart [incidents]="filteredIncidents" />
    <div class="flex flex-col gap-4">
      <div
        [formGroup]="filterForm"
        class="mb-4"
        [attr.data-testid]="'incidents' | appendTestId: 'filter'">
        <aw-text-input
          id="search-filter"
          [placeholder]="cmsTextProvider.incidentMonitor.searchPlaceholder"
          formControlName="search"></aw-text-input>
      </div>
      <aw-table
        [isLoading]="incidentStore.isLoading()"
        id="ticket-table"
        [data]="filteredIncidents"
        [header]="header"
        [columns]="columns"
        (pageChange)="filterForm.updateValueAndValidity()">
        <ng-template #header let-sortBy="sortBy">
          <aw-table-header
            cellName="code"
            [sortParams]="{
              attribute: 'code',
              compare: incidentCodeFilter,
            }"
            class="w-full overflow-hidden"
            [attr.data-testid]="'incidents' | appendTestId: 'header-code'"
            (onSort)="sortBy($event)">
            Code
          </aw-table-header>
          <aw-table-header
            cellName="text"
            [sortParams]="{
              attribute: 'text',
              compare: incidentMessageFilter,
            }"
            class="w-full overflow-hidden"
            [attr.data-testid]="'incidents' | appendTestId: 'header-message'"
            (onSort)="sortBy($event)">
            {{ cmsTextProvider.incidentMonitor.message }}
          </aw-table-header>
          <aw-table-header
            cellName="createdAt"
            [sortParams]="{
              attribute: 'createdAt',
              compare: dateCreatedAtFilter,
            }"
            class="w-full overflow-hidden"
            [attr.data-testid]="'incidents' | appendTestId: 'header-createdAt'"
            (onSort)="sortBy($event)">
            {{ cmsTextProvider.shared.creationDate }}
          </aw-table-header>
        </ng-template>
        <ng-template #columns let-data="data">
          <aw-table-cell
            cellName="code"
            class="min-h-12 w-full p-3"
            [attr.data-testid]="'incidents' | appendTestId: 'code-' + data.id">
            {{ data.code }}
          </aw-table-cell>
          <aw-table-cell
            cellName="text"
            class="w-full p-3"
            [attr.data-testid]="
              'incidents' | appendTestId: 'message-' + data.id
            ">
            {{ getMessage(data.code) | language }}
          </aw-table-cell>
          <aw-table-cell
            cellName="createdAt"
            class="w-full p-3"
            [attr.data-testid]="
              'incidents' | appendTestId: 'createdAt-' + data.id
            ">
            {{ data.createdAt | date: DATE_FORMAT_LONG }}
          </aw-table-cell>
        </ng-template>
      </aw-table>
    </div>
  </aw-section>
}
